<template>
  <div class="ErrorRecords">
    <div class="status">
      <el-menu
      :default-active="activeIndex"
      mode="horizontal"
      @select="handleSelect"
      text-color="#fff"
      active-text-color="#359186">
        <el-menu-item class="hItem" index="状态"> 故障类型 : </el-menu-item>
<!--        <el-menu-item index="全部">全部(<span>{{allNum}}</span>)</el-menu-item>-->
        <el-menu-item index="数据不更新">数据不更新(<span>{{dataNum}}</span>)</el-menu-item>
<!--        <el-menu-item index="波形不更新">波形不更新(<span>{{waveNum}}</span>)</el-menu-item>-->
        <el-menu-item index="报警数据无波形">报警数据无波形(<span>{{alarmNum}}</span>)</el-menu-item>
<!--        <el-menu-item index="设备报警">设备报警(<span>{{equipNum}}</span>)</el-menu-item>-->
<!--        <el-menu-item index="节点异常">节点异常(<span>{{nodeNum}}</span>)</el-menu-item>-->
        <el-menu-item index="电池电量报警">电池电量报警(<span>{{batteryNum}}</span>)</el-menu-item>
      </el-menu>
      <el-button type="primary"  size="small" @click="outExcel">导出EXCEL</el-button>
<!--      <el-button-->
<!--          type="primary"-->
<!--          @click="copyToText('12341234')"-->
<!--      >复用户信息</el-button>-->
    </div>
    <div class="choose">
      <span>类型选择：</span>
      <el-select v-model="selectType" placeholder="" size="mini">
        <el-option
        v-for="item in typeOption"
        :key="item.value"
        :label="item.label"
        :value="item.value">
        </el-option>
      </el-select>
      <span v-if="selectType == '前一阶段'">时间选择：</span>
      <el-select v-model="selectTime" placeholder="" size="mini" v-if="selectType == '前一阶段'">
        <el-option
        v-for="item in timeOption"
        :key="item.value"
        :label="item.label"
        :value="item.value">
        </el-option>
      </el-select>
      <!-- <span v-if="selectType == '起止时间'">开始时间：</span> -->
      <el-date-picker size="mini" v-if="selectType == '起止时间'"
      v-model="startTime"
      type="datetimerange"
      range-separator="至">
      </el-date-picker>
      <span  v-if="selectType == '起止月'">选择年月:</span>
      <el-date-picker
      class="dateMonth"
      v-if="selectType == '起止月'"
      v-model="startMonth"
      size="mini"
      type="month">
      </el-date-picker>
      <el-button size="mini" @click="handleClick">刷新</el-button>
    </div>
    <div class="search">
        <span class="wordFind">查找：</span>
        <el-input class="find" v-model="search" size="mini" placeholder="请输入关键字"></el-input>
        <span class="wordPage">选择每页显示的行数：</span>
        <el-select v-model="value" class="page" size="mini">
          <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
          </el-option>
        </el-select>
    </div>
    <div class="statusTable">
      <!-- el-tabel设置height就会出现滚动条且表头跟着滚动条移动 -->
      <el-table
        :data="filterTable"

        height="100%">
        <el-table-column
            type="index"
            :index ="setMenuIndex"
            width="80px"
            label="序号"
        >

        </el-table-column>
        <el-table-column
        prop="groupName"
        label="公司"
        sortable>
        </el-table-column>
        <el-table-column
        prop="companyName"
        label="分公司"
        sortable>
        </el-table-column>
        <el-table-column
        prop="factoryName"
        label="车间"
        sortable>
        </el-table-column>
        <el-table-column
        prop="unitName"
        label="机组"
        sortable>
        </el-table-column>
        <el-table-column
        prop="equipmentName"
        label="设备名"
        sortable>
        </el-table-column>
        <el-table-column
        prop="pointName"
        label="测点名称"
        width="150px"
        sortable>
        </el-table-column>
        <el-table-column
            prop="value"
            label="特征值"
            width="150px"
            sortable>
        </el-table-column>
        <el-table-column
        prop="status"
        label="故障类型"
        width="150px"
        sortable>
        </el-table-column>
        <el-table-column
        prop="alarmTime"
        label="故障时间"
        width="220px"
        sortable>
        </el-table-column>
<!--        <el-table-column-->
<!--        prop="emailID"-->
<!--        label="邮件ID" >-->
<!--        </el-table-column>-->
        <el-table-column
            prop="emailStatus"
            label="邮件状态" >
        </el-table-column>


        <el-table-column
        label="详细信息"
        width="80px">
        <template #default="scope" >
          <el-button type="info" size="mini" @click="handleEdit(scope.$index, scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
      </el-table>
    </div>
    <el-pagination
      layout="prev, pager, next"
      :total="filterTablePageNum*10"
      @current-change="handleCurrentChange"
      :current-page="currentPage">
    </el-pagination>
  </div>
</template>

<script>
import {ref, onBeforeMount, computed, watch} from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import FileSaver from 'file-saver'
 import {export_json_to_excel} from '../components/ExportFiles/Export2Excel.js'
import XLSX from 'xlsx'
import {useStore} from 'vuex'
import useClipboard from 'vue-clipboard3'
import axios from 'axios'
import {Check} from "@element-plus/icons-vue";

export default {
  name: 'ErrorRecords',
  setup(props, ctx){
    let activeIndex = ref('数据不更新');
    let tableData = ref([]);
    let tmpTableData = ref([]);
    let search = ref('');
    let value = ref(10);
    let totalNum = ref(0);
    let currentPage = ref(1);
    let selectType = ref('前一阶段');
    let selectTime = ref('前1月');
    let startMonth = ref(new Date());
    let startTime = ref([
      new Date().setTime(new Date().getTime() - 30 * 24 * 3600 * 1000),
      new Date().getTime()
    ]);
    let stime = ref('');
    let etime = ref('');
    let treeWidth = computed(() => {
      return store.state.contentWidth;
    })
    let timeOption = ref([{
          value: '前5分钟',
          label: '前5分钟'
        }, {
          value: '前半小时',
          label: '前半小时'
        }, {
          value: '前1小时',
          label: '前1小时'
        }, {
          value: '前1天',
          label: '前1天'
        }, {
          value: '前1周',
          label: '前1周'
        }, {
          value: '前1月',
          label: '前1月'
        }, {
          value: '前1季度',
          label: '前1季度'
        }, {
          value: '前1年',
          label: '前1年'
        }])
    let typeOption = ref([
      {
        value: '前一阶段',
        label: '前一阶段'
      },
      {
        value: '起止时间',
        label: '起止时间'
      },
      {
        value: '起止月',
        label: '起止月'
      }
    ])
    let formatJson = (filterVal, jsonData) => {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
    let outExcel = () => {
      //require.ensure([], () => {

        const tHeader = [ '公司', '分公司', '车间', '机组', '设备名', '测点名称', '故障类型', '故障时间', '邮件状态' ];
        const filterVal = [  'groupName', 'companyName', 'factoryName', 'unitName', 'equipmentName', 'pointName', 'status', 'alarmTime', 'emailStatus'];
        const list = filterTable.value;
        const data =  formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, '异常记录表  导出时间 : '+timestampToTime(new Date().valueOf()) );
     // })
    }
    let options = ref([
      {
        value: 10,
        label: 10
      },
      {
        value: 15,
        label: 15
      },
      {
        value: 25,
        label: 25
      },
      {
        value: 50,
        label: 50
      },
      {
        value: 100,
        label: 100
      }
    ])
    let store = useStore();
    watch(() => store.state.nodeLable, () => {
      // console.log('点击了设备树');
      getTableData();
      return ;
      let items = tmpTableData.value;
      let items1;
      // console.log(activeIndex.value);
      if (activeIndex.value == '状态' || activeIndex.value == '全部') {
        items1 = items.filter((item) => {
          return Object.keys(item).some((key1) => {
            return item[key1] == store.state.nodeLable && (stime && new Date(item['time']).getTime() >= stime.value && new Date(item['time']).getTime() <= etime.value || !stime.value);
          })
        })
      } else {
        items1 = items.filter((item) => {
        return Object.keys(item).some((key1) => {
          return item[key1] == store.state.nodeLable && (stime && new Date(item['time']).getTime() >= stime.value && new Date(item['time']).getTime() <= etime.value || !stime.value);
        }) && Object.keys(item).some((key1) => {
          return item[key1] == activeIndex.value && (stime && new Date(item['time']).getTime() >= stime.value && new Date(item['time']).getTime() <= etime.value || !stime.value);
        })
      })
      }
      tableData.value = items1;
    })
    let timestampToTime = (timestamp) => {
      let date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '年';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月';
      let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' 日 ';
      let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      //let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()) + '.';
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()) ;

      let ms = (timestamp % 1000).toString()
      while (ms.length < 3) {
        ms = '0' + ms
      }
      // return Y + M + D + h + m + s + ms;
      return Y + M + D + h + m + s ;
    }
    let handleSelect = (key, keyPath) => {
      activeIndex.value = key;
      filterTablePageNum.value = statusMapRowNum(activeIndex.value)/value.value ;

      console.log(store.state.nodeLable,'  1  ',activeIndex.value,filterTablePageNum);
      getTableData();
      // if (!store.state.nodeLable) {
      //   if (key != '状态') {
      //     if (key == '全部') {
      //       tableData.value = tmpTableData.value;
      //     } else {
      //       let items = tmpTableData.value;
      //       let items1 = items.filter((item) => {
      //         console.log(item['updateTime'],stime.value,etime.value);
      //         return item['status'] == key && (stime && new Date(item['updateTime']).getTime() >= stime.value && new Date(item['updateTime']).getTime() <= etime.value || !stime.value);
      //       })
      //       tableData.value = items1;
      //     }
      //   }
      // } else {
      //   let items = tmpTableData.value;
      //   let items1;
      //   if (key != '状态') {
      //     if (key == '全部') {
      //       items1 = items.filter((item) => {
      //         return Object.keys(item).some((keys) => {
      //           return item[keys] == store.state.nodeLable && (stime && new Date(item['updateTime']).getTime() >= stime.value && new Date(item['updateTime']).getTime() <= etime.value || !stime.value);
      //         })
      //       })
      //     } else {
      //       items1 = items.filter((item) => {
      //         return item['status'] == key && Object.keys(item).some((keys) => {
      //           return item[keys] == store.state.nodeLable && (stime && new Date(item['updateTime']).getTime() >= stime.value && new Date(item['updateTime']).getTime() <= etime.value || !stime.value);
      //         });
      //       })
      //     }
      //   }
      //   tableData.value = items1;
      // }
      // console.log('切换状态', activeIndex.value);
    }
    let setMenuIndex =((index) => {     ///计算表格中的序号
                                        // console.log(value)
      return index+1+value.value*(currentPage.value-1)
    })
    let statusMapRowNum =( (statu) => {              ///此函数用于将所选中的状态从汉字转换成适应后端接口的字段数量
      // if (statu == '全部') return allNum.value;
      if (statu == '数据不更新')   return dataNum.value ;
      if (statu == '报警数据无波形') return alarmNum.value ;
      if (statu == '电池电量报警') return batteryNum.value ;
    });
    let statusMapStatus =( (statu) => {              ///此函数用于:返回当前状态下的url
      // if (statu == '全部') return allNum.value;
      if (statu == '数据不更新')   return '/exception/not/change' ;
      if (statu == '报警数据无波形') return "/exception/alarmData/noWave" ;
      if (statu == '电池电量报警') return '/exception/battery/alarm' ;
    });
    let getStatesNumber=( (url) => {      ///获取状态数量的函数
      let info = store.state.nodeData
      for(let i=0;i<5;i++){
        url += '/'+info.node[i]
      }
      if(stime.value ==''){
        handleClick();
      }
      url +='/'+stime.value+'/'+etime.value+'/'+(search.value==""?"empty":search.value);
      let number=-1;
      return axios.get(url)
    })
    let getTableData = (() => {

      let noWaveNumberUrl = '/api1/exception/alarmData/noWavePage';
      let noChangeNumberUrl = '/api1/exception/notChange/page'
      let batteryNumberUrl = "/api1/exception/battery/page"
      getStatesNumber(noWaveNumberUrl).then( (res) => {
         alarmNum.value =  res.data.data.count;
         filterTablePageNum.value = statusMapRowNum(activeIndex.value)/value.value ;
       }) ;
        getStatesNumber(noChangeNumberUrl).then( (res) => {
          dataNum.value = res.data.data.count;
          filterTablePageNum.value = statusMapRowNum(activeIndex.value)/value.value ;
        }) ;
      getStatesNumber(batteryNumberUrl).then( (res) => {
        batteryNum.value = res.data.data.count;
        filterTablePageNum.value = statusMapRowNum(activeIndex.value)/value.value ;
      });
      let getDataUrl='/api1';
      getDataUrl+=statusMapStatus(activeIndex.value);
      let info = store.state.nodeData
      for(let i=0;i<5;i++){
        getDataUrl+= '/'+info.node[i]
      }
      console.log('开始获取数据')
      getDataUrl +='/'+stime.value+'/'+etime.value+'/'+(search.value==""?"empty":search.value) + '/'+value.value+'/'+currentPage.value;
      axios.get(getDataUrl).then(res => {
        console.log(res.data.data)
        if (res.data.code == 200) {

//          let data = res.data.data;
          let data=[];
            let item = res.data.data
            for(let i = 0;i<item.length;i++){
           //   console.log(item[i].alarmTime,item[i].alarmEndTime,item[i].alarmStartTime, item[i].updateTime, item[i].alarmUpdateTime)
              if(typeof (item[i].alarmEndTime)  == typeof (1)){
                item[i].updateTime = item[i].alarmEndTime;
              }
              if(typeof ( item[i].alarmStartTime) == typeof (1)){
                item[i].alarmTime=item[i].alarmStartTime;
                item[i].startTime = item[i].alarmStartTime;
              }
              if(typeof (item[i].alarmUpdateTime)  == typeof (1)){
                item[i].updateTime = item[i].alarmUpdateTime;
              }
              if(item[i].alarmTime == undefined){
                item[i].alarmTime = item[i].startTime
              }
              // if(item[i].alarmTime == )
              if(item[i].status == '数据不更新')
                item[i].updateTime = item[i].startTime + item[i].keepTime;
              item[i].value +=  ' '+item[i].unit;
              item[i].alarmTime = timestampToTime(item[i].alarmTime) +' 至 '+timestampToTime(item[i].updateTime);


              if(item[i].emailStatus=='已发送')
                 data.push(item[i]);
            }

          console.log(data);
          tableData.value = data;
          tmpTableData.value = data;
          let items;
          if (store.state.nodeLable) {
            items = tableData.value.filter((item) => {
              return Object.keys(item).some((key) => {
                return item[key] == store.state.nodeLable;
              })
            })
            tableData.value = items;
          }
          totalNum.value = tableData.value.length;
          // allNum.value = data.length;
          // console.log('长度',tableData.value.length);
          // console.log(data);
        }
      })
    })
    let handleCurrentChange = ((val) => {       ///更改页码，跳转到对应的第val的页
      currentPage.value = val;
      getTableData();
    })
    let handleEdit = ((index, row) => {
       console.log(index, row);
//      let message = '<div  > 故 障 类 型：'  + ' <el-button type="success" @click="copyToText" :icon="Check" v-clipboard:copy="row"     v-clipboard:success="onCopySuccess"   "v-clipboard:error="onCopyError" > row.status </el-button> <br>' + '设备 Uuid ：' + row['equipmentUuid'] + '<br>' + '  测  点  i d  ： '+' '+row['pointName'] +'<br> 开始时间戳：'+ row['startTime'] +'<br> 结束时间戳： '+row['updateTime'] +'</div>';

      let message = '<div  > 故 障 类 型：'  +    row.status  +' <br>' + '设备 Uuid ：' + row['equipmentUuid'] + '<br>' + '  测  点  i d  ： '+' '+row['pointName'] +'<br> 开始时间戳：'+ row['startTime'] +'<br> 结束时间戳： '+row['updateTime'] +'</div>';
      if(row.status == '数据不更新'){
        message = '<div  > 故 障 类 型：'  +    row.status  +' <br>' + '设备 Uuid ：' + row['equipmentUuid'] + '<br>' + '  测  点  i d  ： '+' '+row['pointName'] +'<br> 开始时间戳：'+ row['startTime'] +'<br> 开始时间：'+ timestampToTime(row['startTime'])+'<br> 保持时间： '+(row['keepTime']/3600000).toFixed(2) +' 小时</div>';

      }
      if (row['status'] == '电池电量报警') {
        message = '<div>电池状态：电池电量过低<br>' + '设备Uuid：' + row['equipmentUuid'] +'<br>' + '测点id：'+row['pointName']+'<br> </div>';
      }
      ElMessageBox.alert(message, '详细信息', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        callback: (action) => {
          // ElMessage({
          //   type: 'info',
          //   message: `action: ${action}`,
          // })
        },
      })
    })
    const {toClipboard} = useClipboard();
    let copyToText = (async (str) => {
      console.log('1234', str);
      try {
        await toClipboard(str)
        console.log('Copied to clipboard')
      } catch (e) {
        console.error(e)
      }
    })
    let handleClick = (() => {
      // console.log('类型选择', selectType.value, '时间选择', selectTime.value, startTime.value, startMonth.value);
      let items = tmpTableData.value;
      let items1;
      if (selectType.value == '前一阶段') {
        stime.value = '', etime.value = new Date().getTime();
        if (selectTime.value == '前1月') {
          stime.value = etime.value - 30 * 24 * 3600 * 1000;
        } else if (selectTime.value == '前5分钟') {
          stime.value = etime.value - 5 * 60 * 1000;
        }  else if (selectTime.value == '前1周') {
          stime.value = etime.value - 7*60 * 60 * 1000;
        } else if (selectTime.value == '前半小时') {
          stime.value = etime.value - 30 * 60 * 1000;
        } else if (selectTime.value == '前1小时') {
          stime.value = etime.value - 60 * 60 * 1000;
        } else if (selectTime.value == '前1天') {
          stime.value = etime.value - 24 * 3600 * 1000;
        } else if (selectTime.value == '前1季度') {
          stime.value = etime.value - 90 * 24 * 3600 * 1000;
        } else if (selectTime.value == '前1年') {
          stime.value = etime.value - 365 * 24 * 3600 * 1000;
        }
        // console.log('起止时间', stime.value, etime.value);
        items1 = items.filter((item) => {
          let nodeTime = new Date(item['updateTime']).getTime();
           // console.log('数据时间', nodeTime,item['updateTime'],item['pointName'],stime.value,etime.value,item);
          return nodeTime >= stime.value && nodeTime <= etime.value && (!store.state.nodeLable || store.state.nodeLable && Object.keys(item).some((key1) => {
            return item[key1] == store.state.nodeLable;
          })) && ((activeIndex.value != '全部' && activeIndex.value != '状态' && item['status'] == activeIndex.value) || activeIndex.value == '全部' || activeIndex.value == '状态');
        })
      } else if (selectType.value == '起止时间') {
        // console.log(startTime.value[0]);
        stime.value = startTime.value[0];
        etime.value = startTime.value[1];
        items1 = items.filter((item) => {
          // console.log()
          let nodeTime = new Date(item['updateTime']).getTime();
        //   console.log('数据时间', nodeTime,item['updateTime'],item['pointName'],stime.value,etime.value,item);

          return startTime.value[0] <= nodeTime && startTime.value[1] >= nodeTime && (!store.state.nodeLable || store.state.nodeLable && Object.keys(item).some((key1) => {
            return item[key1] == store.state.nodeLable;
          })) && ((activeIndex.value != '全部' && activeIndex.value != '状态' && item['status'] == activeIndex.value) || activeIndex.value == '全部' || activeIndex.value == '状态');
        })
      } else if (selectType.value == '起止月') {
        let year = new Date(startMonth.value).getFullYear();
          let month = new Date(startMonth.value).getMonth() + 1;
          // console.log('年 月', year, month);
          stime.value = '', etime.value = '';
          let list = {
            1: 31,
            2: 28,
            3: 31,
            4: 30,
            5: 31,
            6: 30,
            7: 31,
            8: 31,
            9: 30,
            10: 31,
            11: 30,
            12: 31,
          }
          if (year % 400 == 0 || year % 4 == 0 && year % 100 != 0) {
            list['2'] = 29;
          }
          etime.value = new Date(`${year}-${month}-${list[month]} 23:59:59:999`).getTime();
          stime.value = new Date(`${year}-${month}-01 00:00:00:000`).getTime();

      }
      getTableData();
    })
    let allNum = computed(() => {
      return tmpTableData.value.filter((item) => {
        return Object.keys(item).some((keys) => {
          if (!store.state.nodeLable) {
            return true;
          } else {
            return item[keys] == store.state.nodeLable;
          }
        }) && Object.keys(item).some((key1) => {
            if (!search) {
              return true;
            }
            return String(item[key1])
            .toLowerCase()
            .match(search.value);
          }) && (stime && new Date(item['updateTime']).getTime() >= stime.value && new Date(item['updateTime']).getTime() <= etime.value || !stime.value)
      }).length;
    })
    let norNum = computed(() => {
      return tmpTableData.value.filter((item) => {
        return item['status'] == '正常' && Object.keys(item).some((keys) => {
          if (!store.state.nodeLable) {
            return true;
          } else {
            return item[keys] == store.state.nodeLable;
          }
        }) && Object.keys(item).some((key1) => {
            if (!search) {
              return true;
            }
            return String(item[key1])
            .toLowerCase()
            .match(search.value);
          }) && (stime && new Date(item['updateTime']).getTime() >= stime.value && new Date(item['updateTime']).getTime() <= etime.value || !stime.value);
      }).length
    });
    let dataNum = ref(0);
    let waveNum = ref(0);
    let alarmNum = ref(0);
    let equipNum = computed(() => {
      return tmpTableData.value.filter((item) => {
        return item['status'] == '设备报警' && Object.keys(item).some((keys) => {
          if (!store.state.nodeLable) {
            return true;
          } else {
            return item[keys] == store.state.nodeLable;
          }
        }) && Object.keys(item).some((key1) => {
            if (!search) {
              return true;
            }
            return String(item[key1])
            .toLowerCase()
            .match(search.value);
          }) && (stime && new Date(item['updateTime']).getTime() >= stime.value && new Date(item['updateTime']).getTime() <= etime.value || !stime.value);
      }).length
    });
    let nodeNum = computed(() => {
      return tmpTableData.value.filter((item) => {
        return item['status'] == '节点异常' && Object.keys(item).some((keys) => {
          if (!store.state.nodeLable) {
            return true;
          } else {
            return item[keys] == store.state.nodeLable;
          }
        }) && Object.keys(item).some((key1) => {
            if (!search) {
              return true;
            }
            return String(item[key1])
            .toLowerCase()
            .match(search.value);
          }) && (stime && new Date(item['updateTime']).getTime() >= stime.value && new Date(item['updateTime']).getTime() <= etime.value || !stime.value);
      }).length
    });
    let batteryNum = ref(0);
    let filterTable = computed(() => {
      let input = search.value && search.value.toLowerCase();
      let items = tableData.value;
      let items1;
      if (input) {
        items1 = items.filter((item) => {
          return Object.keys(item).some((key1) => {
            return String(item[key1])
            .toLowerCase()
            .match(input);
          })
        })
      } else {
        items1 = items;
      }
      return items;
    })
    let filterTablePageNum = ref(0);   ///获取活动状态的总页码数量；
    onBeforeMount(() => {
      getTableData();
    })
    return {
      allNum,
      norNum,
      copyToText,
      dataNum,
      waveNum,
      alarmNum,
      equipNum,
      nodeNum,
      batteryNum,
      activeIndex,
      tableData,
      search,
      options,
      value,
      selectType,
      totalNum,
      currentPage,
      selectTime,
      timeOption,
      filterTable,
      tmpTableData,
      typeOption,
      startTime,
      startMonth,
      stime,
      etime,
      treeWidth,
      handleSelect,
      getTableData,
      handleCurrentChange,
      handleEdit,
      handleClick,
      outExcel,
      getStatesNumber,
      setMenuIndex,
      filterTablePageNum,///表格的页码数量
    }
  }
}
</script>

<style lang="scss">
  .ErrorRecords{
    width: calc(100% - v-bind(treeWidth));
    margin-right: 10px;
    height: calc(100vh - 70px);
    margin-bottom: 10px;
    background-color: #303749;
    // background-color: #bfa;
    :root {
      --el-color-primary: #409eff;
      --el-color-success: #67c23a;
      --el-color-warning: #e6a23c;
      --el-color-danger: #f56c6c;
      --el-color-error: #f56c6c;
      --el-color-info: #909399;
    }
    .status{
      height: 10%;
      background-color: #2c3242;
      position: relative;
      margin-left: 10px;
      margin-right: 10px;
      margin-top: 10px;
      .el-menu{
        height: 100%;
        background-color: #2c3242;
        border-bottom: 0px;
        display: flex;
        align-items: center; //垂直居中
        // justify-content: center;
        .el-menu-item.hItem{
          font-size: 20px;
        }
        .el-menu-item{
          color: #fff;
          font-size: 13px;
          border-bottom: 0px;
        }
        .el-menu-item.is-active{
          background-color: #2c3242 !important;
          color: #359186;
          border-bottom: 0px;
        }
        .el-menu-item.hItem.is-active{
          background-color: #2c3242 !important;
          color: #fff !important;
          border-bottom: 0px;
        }
        .el-menu-item:hover{
          background-color: #2c3242 ;
          color: #359186;
        }
        .el-menu-item.hItem:hover{
          background-color: #2c3242;
          color: #fff;
        }
      }
      .el-button:hover{
        border-color: #42b983;
        color: #42b983;
      }
      .el-button{
        position: absolute;
        background-color: #2C3242;
        border-color: #fff;
        //display: flex;
        align-items: center; //垂直居中
        right: 30px;
        bottom: 0;
      }
    }
    .choose{
      display: flex;
      align-items: center;
      height: 6%;
      margin: 0 10px;
      background-color: #2c3242;
      // background-color: #303749;
      .el-form-item__label{
        color: white;
      }
      span{
        font-size: 13px;
        margin-left: 10px;
        color: #fff;
      }
      .el-select .el-input .el-input__inner{
        border: 1px solid #fff;
        text-align: center;
      }
      .el-select{
        .el-input{
          width: 120px;

        }
      }
      .el-input__inner{
        background-color: #2c3242;
        color: #fff;
      }
      .el-button{
        margin-left: 10px;
        background-color: #2c3242;
        border: 1px solid #fff;
        span{
          margin-left: 0px;
        }
      }
      // .el-date-editor.is-active:hover{
      //   border: 1px solid #fff;
      // }
      .el-date-editor {
        margin-left: 10px;
        background-color: #2c3242;
        border: 1px solid #fff;
        .el-range-input{
          background-color: #2c3242;
          color: #fff;
        }
      }
      .el-date-editor.dateMonth{
        width: 150px;
        border: 0px;
        .el-input__inner{
          width: 150px;
          text-align: center;
        }
        span{
          margin-left: 0px;
        }
      }
    }
    .search{
      display: flex;
      margin: 0px 10px;
      position: relative;
      align-items: center;
      span{
        margin-top: 10px;
        font-size: 13px;
        color: #fff;
      }
      span.wordFind{
        margin-left: 5px;
      }
      .el-input{
        // margin-left: 10px;
        margin-top: 10px;
        width: 200px;
        .el-input__inner{
          background-color: #303749;
          color: #fff;
          border: 1px #fff solid;
        }
      }
      .el-input .el-input__inner.active{
        border: 1px red solid;
      }
      .el-select .el-input{
        width: 100px;
        .el-input__inner{
          text-align: center;
          border: 1px #fff solid;
        }
        .el-input__suffix, .el-input__suffix-inner{
          margin-top: 0px;
        }
      }
      span.wordPage{
        position: absolute;
        right: 100px;
      }
      .el-select.page{
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
    .statusTable{
      margin-left: 10px;
      margin-right: 10px;
      background-color: #2c3242;
      height: 65%;
      //去除表格最下面那条线
      .el-table::before{
        height: 0px;
      }
      .el-table{
        background-color: #2c3242;
        //去除表头下面那条线
        th.el-table__cell.is-leaf{
          border-bottom: 0px;
        }
        //设置排序图标的颜色
        // .descending .sort-caret.descending {
        //   border-top-color: #359186;
        // }
        // .ascending .sort-caret.ascending {
        //   border-bottom-color: #359186;
        // }
        .cell{
          text-align: center;
        }
        th{
          background-color: #2c3242;
          color: #fff;
          // border-right: 1px solid rgba(256, 256, 256, 0.5);
        }
        tr{
          background-color: #2c3242;
          color: #fff;
          td{
            border-bottom: 0px;
          }
        }
        tr:hover td{
          background-color: rgba(107, 199, 255, 0.98) !important;
        }
      }
    }
    .el-pagination{
      margin-top: 10px;
      display: flex;
      align-items: center; //垂直居中
      ul li{
        background-color: #303749;
        color: #fff;
      }
      ul li.active{
        color: #359186;
      }
      ul li:hover{
        color: #359186;
      }
      .btn-prev{
        background-color: #303749;
        .el-icon{
          color: #fff;
        }
        .el-icon:hover{
          color: #359186;
        }
      }
      .btn-next{
        background-color: #303749;
        .el-icon{
          color: #fff;
        }
        .el-icon:hover{
          color: #359186;
        }
      }
    }
  }
</style>
